import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { MuseumStoreLogo } from './A250MuseumStoreLogo';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Custom Products',
    href: '#'
  }, {
    name: 'Fox & Chave',
    href: '#'
  }, {
    name: 'About',
    href: '#'
  }, {
    name: 'Blog',
    href: '#'
  }];
  return <header className={`sticky top-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-museum-blue/95 backdrop-blur-xl py-3' : 'bg-museum-blue py-4'}`} data-id="element-155">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-156">
        <div className="flex justify-between items-center" data-id="element-157">
          {/* Logo Section with A250 Partnership */}
          <div className="flex items-center gap-6" data-id="element-158">
            {/* Main Logo */}
            <div className="flex items-center gap-2 cursor-pointer" data-id="element-159">
              <div className="relative h-8 w-8 border-l-2 border-b-2 border-white flex items-end justify-start p-0.5" data-id="element-160">
                <div className="absolute top-0 right-0 h-2 w-2 border-t-2 border-r-2 border-white" data-id="element-161"></div>
              </div>
              <div className="flex flex-col leading-none" data-id="element-162">
                <span className="font-sans font-bold text-base tracking-wide text-white" data-id="element-163">
                  MUSEUM STORE
                </span>
                <span className="font-sans font-medium text-[10px] tracking-widest text-white/70" data-id="element-164">
                  PRODUCTS
                </span>
              </div>
            </div>

            {/* A250 Partnership Logo */}
            <div className="hidden md:flex items-center" data-id="element-165">
              <div className="h-8 w-px bg-white/30 mr-5" data-id="element-166"></div>
              <MuseumStoreLogo size="small" loading="eager" className="h-10" data-id="element-167" />
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-168">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-white/90 hover:text-white transition-colors" data-id="element-169">
                {link.name}
              </a>)}
            <a href="#" className="bg-white text-museum-blue px-5 py-2.5 rounded-full text-sm font-semibold hover:bg-gray-100 transition-colors duration-300" data-id="element-170">
              Contact Us
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button className="lg:hidden text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-171">
            {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-172" /> : <Menu className="w-6 h-6" data-id="element-173" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-174">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden bg-museum-blue border-t border-white/10 overflow-hidden absolute top-full left-0 w-full" data-id="element-175">
            <div className="px-6 py-8 space-y-6" data-id="element-176">
              {/* A250 Logo in Mobile */}
              <div className="pb-4 border-b border-white/10" data-id="element-177">
                <MuseumStoreLogo size="small" className="h-10" data-id="element-178" />
              </div>
              {navLinks.map(link => <a key={link.name} href={link.href} className="block text-lg font-medium text-white" data-id="element-179">
                  {link.name}
                </a>)}
              <a href="#" className="block w-full text-center bg-white text-museum-blue px-5 py-3 rounded-full text-base font-semibold" data-id="element-180">
                Contact Us
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}